/**
 * App Layout
 * Main layout for authenticated pages
 * Uses shadcn/ui components for consistent styling
 * 
 * Layout structure:
 * - Left Sidebar (fixed)
 * - Main Content Area (scrollable)
 * - Right Sidebar (fixed)
 */

import { Outlet, useLocation } from 'react-router';
import { Sidebar } from '@/components/Sidebar';
import { Header } from '@/components/Header';
import { GlobalRightSidebar, RightSidebarProvider } from '@/components/sidebar/index';
import { cn } from '@/lib/utils';

export function AppLayout() {
    const location = useLocation();
    // Content pages have their own nested layout, so no padding needed
    const isContentPage = location.pathname.startsWith('/admin/content');

    return (
        <RightSidebarProvider>
            <div className="flex h-screen bg-background overflow-hidden">
                {/* Left Sidebar - Fixed */}
                <Sidebar />

                {/* Main Area - Contains Header + Content */}
                <div className="flex flex-1 flex-col min-w-0 overflow-hidden">
                    <Header />
                    <main className={cn(
                        'flex-1 min-h-0',
                        isContentPage ? 'overflow-hidden' : 'overflow-auto p-6'
                    )}>
                        <Outlet />
                    </main>
                </div>

                {/* Right Sidebar - Fixed */}
                <GlobalRightSidebar />
            </div>
        </RightSidebarProvider>
    );
}
